import React from "react";

const Home = () => {
  return (
    <div className="home-content-wrapper">
      <div className="home-content">
        <h1 className="home-title">
          Frontend Developer from Toronto, Canada
          <br />
          now living in Berlin.
        </h1>
        {/* <p>
          Recent computer programming graduate with developed (WELL VERSED
          IN/disciplined) skills in Javascript, HTML, CSS, React, with unit
          testing in Jest and Enzyme
        </p> */}
      </div>
    </div>
  );
};

export default Home;
